import { Card, CardContent } from "@volca/ui/components/ui/card";
import { PageContainer } from "@volca/ui/components/ui/page-components";
import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { RosterPageHeader } from "./roster-page-header";
import { RosterTableSkeleton } from "./roster-table-skeleton";

export const PayrollRosterLoadingState = () => (
  <PageContainer variant="workspace" aria-busy="true">
    <span className="sr-only">Loading payroll roster</span>
    <Stack align="start" gap={4} className="min-h-0 w-full flex-1">
      <Stack align="start" gap={1} className="w-full shrink-0">
        <RosterPageHeader
          actions={
            <>
              <Skeleton className="h-8 w-36 rounded-lg" />
              <Skeleton className="size-8 rounded-lg" />
            </>
          }
        />
        <Skeleton className="h-4 w-72 max-w-full" />
      </Stack>

      <Stack direction="row" align="center" gap={2} className="flex-wrap">
        <Skeleton className="h-9 w-76 max-w-full" />
        <Skeleton className="h-9 w-20 rounded-full" />
        <Skeleton className="h-9 w-24 rounded-full" />
        <Skeleton className="h-9 w-24 rounded-full" />
        <Skeleton className="h-9 w-28 rounded-full" />
      </Stack>

      <Card className="flex min-h-0 w-full min-w-0 flex-1 flex-col gap-0 overflow-hidden py-0">
        <CardContent className="flex min-h-0 flex-1 flex-col p-0">
          <RosterTableSkeleton />
        </CardContent>
      </Card>
    </Stack>
  </PageContainer>
);
